const initialState={
	solicitudes:[],
	estadoSolicitud:0	
};

export default function solicitudReducer(state= initialState,action){
	switch(action.type){
		case 'SOLICITUDES':
     		return {...state,solicitudes:action.payload};
     	case 'SOLICITUDES_ESTADO':
     		return {...state,estadoSolicitud:action.payload};
     	default:
     		return state
	}
}